export default __webpack_public_path__ + "ui/assets/img/sale-20.svg";